module.exports = __webpack_public_path__ + "photo1@2x.png?3355c336f6632f1565c9e81ee9d7bb77";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/photo1@2x.png
// module id = 57
// module chunks = 0